var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex flex-column justify-center align-center "},[_c('h1',{class:{
      'display-2': true,
      'mb-3': true,
      'font-weight-light': true,
      'white--text': _vm.light
    }},[_vm._v(" Психолог ")]),_c('h1',{class:{
      'display-3': true,
      'mb-3': true,
      'text-center':true,
      'font-weight-light': true,
      'white--text': _vm.light}},[_vm._v("Мария Юдина")]),_c('p',{class:{'title': true, 'font-weight-light': true, 'white--text': _vm.light}},[_vm._v("Психологическая помощь")]),_c('router-link',{class:{
        'my-4': true,
        'v-btn': true,
        'v-btn--contained': true,
        'v-btn--rounded': true,
        'theme--light': true,
        'v-size--default' : true,
        'secondary': !_vm.light,
        'text-center' :true,
        },attrs:{"to":"/sign_up"}},[_c('span',{class:{
        'v-btn__content' : true,
        'black--text': _vm.light,
        }},[_vm._v(" Записаться на консультацию ")])]),_c('v-btn',{attrs:{"dark":_vm.light,"fab":"","outlined":""},on:{"click":function($event){return _vm.$vuetify.goTo('#about-me')}}},[_c('v-icon',[_vm._v("mdi-chevron-double-down")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }